import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import { useMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { EnumSortDirection } from '@hooks/useRequest';
import { IUsuario } from '@model/Usuario';
import { EnumUsuarioStatus, useUsuarioStatusCombo } from '@model/UsuarioStatus';
import { IUsuarioFilter, useUsuarioService } from '@services/UsuarioService';
import React from 'react';
import { UsuarioFilter } from './UsuarioFilter';
import { UsuarioMenu } from './UsuarioMenu';
import { UsuarioRegistrarModal } from './UsuarioRegistrarModal';
import { UsuarioTable } from './UsuarioTable';

export type UsuarioProps = {
}

export function Usuario (props: UsuarioProps) {
    const data = useData<IUsuario, IUsuarioFilter>({
        filter: {
            nome: useField(),
            usuarioStatusId: useField(EnumUsuarioStatus.Ativo)
        },

        sortField: {
            name: "nome",
            direction: EnumSortDirection.Asc
        }
    })

    const loading = useLoading();
    const message = useMessage();
    const usuairoService = useUsuarioService();
    const menu = useMenu();
    const usuarioStatusCombo = useUsuarioStatusCombo();

    const usuarioRegistrarModal = useModalWindow();

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            usuairoService.listar(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        usuarioStatusCombo.loadOptions();
    })

    return (
        <Main>
            <PageTitle>
                <HorizontalGrid>
                    <GridItem>
                        <PageTitleText text="Usuários" />
                    </GridItem>
                    <GridItem floatRight>
                        <PrimaryButton onClick={usuarioRegistrarModal.open}>Novo Usuário</PrimaryButton>
                    </GridItem>
                </HorizontalGrid>
            </PageTitle>

            <PageContent>
                <UsuarioFilter
                    filter={data.filter}
                    isLoading={loading.isLoading}
                    usuarioStatusCombo={usuarioStatusCombo}
                />
                
                <UsuarioTable 
                    data={data}
                    isLoading={loading.isLoading}
                    menu={menu}
                />
            </PageContent>

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <UsuarioMenu 
                            menu={menu}
                            commandLoading={loading}
                            onUsuarioAtualizado={data.handleUpdateFocusedRow}
                            usuario={data.focusedRow}
                        />
                    </React.Fragment>
                )
            }

            <UsuarioRegistrarModal 
                modal={usuarioRegistrarModal}
                onUsuarioRegistrado={data.filter.handleFilterRequest}
            />
        </Main>
    )
}